/** Copy MD / Download MD for any page: the server renders the Markdown (GET /api/export/{page}.md). */
import { apiFileUrl } from "./identity";

export function exportUrl(page: string, params: Record<string, string | number | undefined>, download = false): string {
  return apiFileUrl(`/api/export/${page}.md`, { ...params, download: download ? 1 : undefined });
}

export async function fetchMarkdown(page: string, params: Record<string, string | number | undefined>): Promise<string> {
  const r = await fetch(exportUrl(page, params), { credentials: "same-origin" });
  if (!r.ok) throw new Error(`export failed: HTTP ${r.status}`);
  return r.text();
}

export async function copyText(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const ta = document.createElement("textarea");
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  ta.remove();
}
